/* ========= MODALS (unified, mobile-safe) ========= */
(function initModals() {
  const OPEN_ATTR = 'aria-hidden';

  // 1) collect modals per card BEFORE we portalize them
  const cardToDrawer = new Map();
  document.querySelectorAll('.exp').forEach((card) => {
    const drawer = card.querySelector('.details-drawer');
    if (drawer) {
      cardToDrawer.set(card, drawer);
      drawer.__ownerCard = card; // remember who owns it
    }
  });

  function getDrawerFromCard(card) {
    if (!card) return null;
    // we may have portalized it, but we still keep the map
    return cardToDrawer.get(card) || null;
  }

  function openDrawer(drawer, trigger) {
    if (!drawer) return;

    // move to body once so it’s always on top
    if (!drawer.__portalized) {
      document.body.appendChild(drawer);
      drawer.__portalized = true;
    }

    drawer.setAttribute(OPEN_ATTR, 'false');
    document.body.classList.add('no-scroll');

    // remember opener for focus restore
    if (trigger) {
      drawer.__opener = trigger;
    }

    const closeBtn = drawer.querySelector('.modal-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.setAttribute(OPEN_ATTR, 'true');

    // restore focus to opener (if still in DOM)
    if (drawer.__opener && typeof drawer.__opener.focus === 'function') {
      try { drawer.__opener.focus(); } catch (_) {}
    }

    // if no other modals are open, unlock body
    const stillOpen = document.querySelector('.details-drawer[' + OPEN_ATTR + '="false"]');
    if (!stillOpen) {
      document.body.classList.remove('no-scroll');
    }
  }

  function findCardFromTrigger(trigger) {
    // trigger inside card
    let card = trigger.closest('.exp');
    if (card) return card;

    // trigger in sibling .divBtn
    const btnRow = trigger.closest('.divBtn');
    if (btnRow) {
      let n = btnRow.previousElementSibling;
      for (let i = 0; i < 4 && n; i++) {
        if (n.classList && n.classList.contains('exp')) return n;
        n = n.previousElementSibling;
      }
    }
    return null;
  }

  /* ---- OPENING (DISCOVER, etc.) ---- */
  document.addEventListener('click', (e) => {
    // if already a modal open, do nothing
    if (document.querySelector('.details-drawer[' + OPEN_ATTR + '="false"]')) return;

    // DISCOVER button
    const trigger = e.target.closest('.details-btn');
    if (trigger) {
      const card = findCardFromTrigger(trigger);
      const drawer = getDrawerFromCard(card);
      openDrawer(drawer, trigger);
      return;
    }

    // click on card header
    const head = e.target.closest('.exp-main, .exp-main-shop');
    if (head) {
      const card = head.closest('.exp');
      const drawer = getDrawerFromCard(card);
      openDrawer(drawer, head);
      return;
    }
  });

  /* ---- KEYBOARD OPEN ---- */
  document.addEventListener('keydown', (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('.details-btn')) {
      e.preventDefault();
      if (document.querySelector('.details-drawer[' + OPEN_ATTR + '="false"]')) return;
      const card = findCardFromTrigger(e.target);
      const drawer = getDrawerFromCard(card);
      openDrawer(drawer, e.target);
    }
  });

  /* ---- ONLY X CAN CLOSE ---- */
  document.addEventListener('click', (e) => {
    if (e.target.matches('.modal-close')) {
      const drawer = e.target.closest('.details-drawer');
      closeDrawer(drawer);
    }
  });

  /* ---- (optional but good) ESC can close ---- */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const openDrawerEl = document.querySelector('.details-drawer[' + OPEN_ATTR + '="false"]');
      if (openDrawerEl) {
        e.preventDefault();
        closeDrawer(openDrawerEl);
      }
    }
  });

  /* 🔴 IMPORTANT: NO BACKDROP CLOSE
     We do NOT add any listener on document for click on .details-drawer.
     Clicking the dark area does NOTHING. Must hit X.
  */

  /* ---- keep your "sync book links" logic ---- */
  function syncBookLinks() {
    cardToDrawer.forEach((drawer, card) => {
      // external card button: in the sibling .divBtn that follows the card
      const externalRow =
        card.nextElementSibling && card.nextElementSibling.classList.contains('divBtn')
          ? card.nextElementSibling
          : null;
      const externalBook = externalRow ? externalRow.querySelector('.book-btn[href]') : null;
      const modalBook = drawer.querySelector('.divBtnModal .book-btn');

      if (externalBook && modalBook) {
        modalBook.setAttribute('href', externalBook.getAttribute('href'));
        modalBook.setAttribute('target', externalBook.getAttribute('target') || '_blank');
        modalBook.setAttribute('rel', externalBook.getAttribute('rel') || 'noopener');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncBookLinks);
  } else {
    syncBookLinks();
  }
})();


/* ========= Tabs → smooth scroll (includes #tourism) ========= */
(function initScrollTabs() {
  const tabs = Array.from(document.querySelectorAll('#div-Onglets .onglet'));
  const sections = Array.from(document.querySelectorAll('.events, #tourism'));
  if (!tabs.length || !sections.length) return;

  const byId = Object.fromEntries(sections.filter(s => s.id).map(s => [s.id, s]));
  tabs.forEach(tab => {
    const go = () => {
      const targetId = tab.getAttribute('data-target');
      const sec = byId[targetId];
      if (!sec) return;
      sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    tab.addEventListener('click', go);
    tab.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
    });
  });

  const obs = new IntersectionObserver(
    (entries) => entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.classList.add('reveal');
      else entry.target.classList.remove('reveal');
    }),
    { root: null, threshold: 0.25 }
  );
  document.querySelectorAll('.events').forEach(sec => obs.observe(sec));
})();

/* ========= Press quotes slider ========= */
(function initPressQuotesFlow(){
  const slider   = document.getElementById('press-slider');
  if (!slider) return;

  const viewport = slider.querySelector('.press-slide-viewport');
  const slides   = Array.from(viewport.querySelectorAll('.press-slide'));
  const prevBtn  = slider.querySelector('.press-prev');
  const nextBtn  = slider.querySelector('.press-next');
  if (!slides.length) return;

  let current = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
  if (current === -1) current = 0;
  slides.forEach((s,i) => s.classList.toggle('is-active', i === current));

  function go(step){
    const out = current;
    const next = (out + step + slides.length) % slides.length;
    if (next === out) return;
    slides[out].classList.remove('is-active');
    slides[next].classList.add('is-active');
    current = next;
  }
  const showNext = () => go(+1);
  const showPrev = () => go(-1);

  prevBtn && prevBtn.addEventListener('click', showPrev);
  nextBtn && nextBtn.addEventListener('click', showNext);

  const autoplay      = slider.getAttribute('data-autoplay') !== 'false';
  const pauseOnHover  = slider.getAttribute('data-pause-autoplay-on-mouseover') === 'true';
  const speedAttr     = Number(slider.getAttribute('data-speed'));
  const INTERVAL_MS   = (!isNaN(speedAttr) && speedAttr > 0 ? speedAttr : 3) * 1000;

  let timer = null;
  function start(){ if (!timer && autoplay) timer = setInterval(showNext, INTERVAL_MS); }
  function stop(){ if (timer){ clearInterval(timer); timer = null; } }

  if (pauseOnHover) {
    const section = document.getElementById('press-quotes');
    if (section) {
      section.addEventListener('mouseenter', stop, { passive: true });
      section.addEventListener('mouseleave', start, { passive: true });
      section.addEventListener('focusin', stop);
      section.addEventListener('focusout', start);
    }
  }
  start();
})();

/* ========= Press viewport height lock ========= */
(function lockPressViewportHeight(){
  const slider   = document.getElementById('press-slider');
  if (!slider) return;
  const viewport = slider.querySelector('.press-slide-viewport');
  const slides   = Array.from(viewport.querySelectorAll('.press-slide'));
  if (!slides.length) return;

  const BUFFER = 24;
  function measureAndLock() {
    viewport.style.height = '';
    const prev = slides.map(s => s.getAttribute('style') || '');
    slides.forEach(s => {
      s.style.position = 'static';
      s.style.visibility = 'hidden';
      s.style.opacity = '1';
      s.style.transform = 'none';
      s.style.pointerEvents = 'none';
      s.style.willChange = 'auto';
    });
    const maxH = Math.max(...slides.map(s => s.scrollHeight)) + BUFFER;
    slides.forEach((s,i) => s.setAttribute('style', prev[i]));
    if (maxH > 0) viewport.style.height = Math.ceil(maxH) + 'px';
  }

  requestAnimationFrame(() => {
    measureAndLock();
    setTimeout(measureAndLock, 120);
  });

  const ro = new ResizeObserver(measureAndLock);
  ro.observe(slider.closest('.press-container') || slider);
  window.addEventListener('resize', measureAndLock, { passive: true });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      measureAndLock();
      setTimeout(measureAndLock, 50);
    }).catch(() => {});
  }

  slider.addEventListener('click', () => {
    const active = viewport.querySelector('.press-slide.is-active');
    if (!active) return;
    const need = active.scrollHeight + BUFFER;
    const have = parseFloat(getComputedStyle(viewport).height);
    if (need > have) viewport.style.height = Math.ceil(need) + 'px';
  }, true);
})();

/* ========= Trusted logos rail (smooth) ========= */
(function initTrustedRail() {
  function init() {
    const section  = document.getElementById('trusted');
    if (!section) return;

    const viewport = section.querySelector('.trusted-viewport');
    const track    = section.querySelector('.trusted-track');
    if (!viewport || !track) return;

    const originals = Array.from(track.children);
    if (originals.length < 3) return;

    const clones = originals.map(n => n.cloneNode(true));
    clones.forEach(n => track.appendChild(n));

    let index  = 0;
    let itemW  = 0;
    let gapPx  = 16;
    let timer  = null;

    const TRANSITION_MS   = 900;
    const EASING          = 'cubic-bezier(.22,1,.36,1)';
    const STEP_EVERY_MS   = 2600;

    function compute() {
      const cs = getComputedStyle(viewport);
      const gapVal = cs.getPropertyValue('--gap').trim();
      gapPx = parseFloat(gapVal || '16');
      const first = track.querySelector('.trusted-item');
      itemW = first ? first.offsetWidth : 0;
      apply(false);
    }

    function apply(animate = true) {
      track.style.transition = animate ? `transform ${TRANSITION_MS}ms ${EASING}` : 'none';
      const dx = index * (itemW + gapPx);
      track.style.transform = `translate3d(${-dx}px, 0, 0)`;
    }

    function tick() {
      const originalCount = originals.length;
      if (!itemW) return;
      index += 1;
      apply(true);
      if (index >= originalCount) {
        setTimeout(() => {
          index -= originalCount;
          apply(false);
          track.offsetHeight; // force reflow
          track.style.transition = `transform ${TRANSITION_MS}ms ${EASING}`;
        }, TRANSITION_MS + 20);
      }
    }

    function start() { if (!timer) timer = setInterval(tick, STEP_EVERY_MS); }
    function stop()  { if (timer) { clearInterval(timer); timer = null; } }

    const ro = new ResizeObserver(compute);
    ro.observe(viewport);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(compute).catch(()=>{});
    track.querySelectorAll('img').forEach(img => {
      if (img.complete) return;
      img.addEventListener('load', compute, { once: true });
      img.addEventListener('error', compute, { once: true });
    });

    viewport.addEventListener('mouseenter', stop);
    viewport.addEventListener('mouseleave', start);
    viewport.addEventListener('focusin',  stop);
    viewport.addEventListener('focusout', start);

    let tries = 0;
    function ensureMeasuredThenStart() {
      compute();
      if (itemW > 0 || tries > 20) start();
      else { tries += 1; setTimeout(ensureMeasuredThenStart, 80); }
    }
    requestAnimationFrame(() => setTimeout(ensureMeasuredThenStart, 0));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ========= Modal image carousels (arrows only) ========= */
(function initModalCarousels() {
  const MODAL_SELECTOR = '.details-drawer';
  const MEDIA_SELECTOR = '.modal-media';
  const EASE_TRANS     = 'transform 650ms cubic-bezier(.22,1,.25,1)';

  const make = (tag, cls, html) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  };

  function buildCarouselFor(media) {
    if (media.dataset.carouselBuilt === '1') return;

    let sources = [];
    const data = media.getAttribute('data-images');
    if (data) {
      try { sources = JSON.parse(data); } catch {}
    }
    if (!sources.length) {
      const imgs = Array.from(media.querySelectorAll('img'));
      if (imgs.length) sources = imgs.map(i => i.currentSrc || i.src).filter(Boolean);
    }
    if (!sources.length) return;

    media.innerHTML = '';

    const root     = make('div', 'carousel');
    const viewport = make('div', 'carousel-viewport');
    const track    = make('div', 'carousel-track');
    viewport.appendChild(track);

    sources.forEach((src, i) => {
      const slide = make('div', 'carousel-slide');
      const img   = make('img');
      img.src = src;
      img.alt = media.getAttribute('aria-label') || `Slide ${i+1}`;
      slide.appendChild(img);
      track.appendChild(slide);
    });

    const prev = make('button', 'carousel-arrow carousel-prev', `
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="m15 18-6-6 6-6"/>
      </svg>
    `);
    prev.setAttribute('aria-label', 'Previous image');

    const next = make('button', 'carousel-arrow carousel-next', `
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="m9 18 6-6-6-6"/>
      </svg>
    `);
    next.setAttribute('aria-label', 'Next image');

    root.appendChild(viewport);
    media.appendChild(root);
    media.appendChild(prev);
    media.appendChild(next);

    let index = 0;
    const count = sources.length;

    const apply = (animate = true) => {
      const style = track.style;
      style.transition = animate ? EASE_TRANS : 'none';
      style.transform  = `translate3d(${-index * 100}%, 0, 0)`;
    };

    const go = (delta) => {
      index = (index + delta + count) % count;
      apply(true);
    };

    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(+1));

    // Keyboard support when modal is open
    const drawer = media.closest(MODAL_SELECTOR);
    if (drawer) {
      drawer.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(+1); }
      });
    }

    // Touch swipe
    let startX = 0;
    let deltaX = 0;
    let dragging = false;

    const viewportEl = viewport; // clarity
    viewportEl.addEventListener('pointerdown', (e) => {
      dragging = true;
      startX = e.clientX;
      deltaX = 0;
      viewportEl.setPointerCapture(e.pointerId);
      track.style.transition = 'none';
    });

    viewportEl.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      deltaX = e.clientX - startX;
      const pct = (-index * 100) + (deltaX / viewportEl.clientWidth) * 100;
      track.style.transform = `translate3d(${pct}%, 0, 0)`;
    });

    const endDrag = (e) => {
      if (!dragging) return;
      dragging = false;
      viewportEl.releasePointerCapture?.(e.pointerId);
      const threshold = viewportEl.clientWidth * 0.18;
      if (deltaX > threshold) go(-1);
      else if (deltaX < -threshold) go(+1);
      else apply(true);
    };

    viewportEl.addEventListener('pointerup', endDrag);
    viewportEl.addEventListener('pointercancel', endDrag);
    viewportEl.addEventListener('pointerleave', endDrag);

    // Initialize
    apply(false);
    media.dataset.carouselBuilt = '1';
  }

  function initAll() {
    document.querySelectorAll(MODAL_SELECTOR + ' ' + MEDIA_SELECTOR).forEach(buildCarouselFor);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

/* ========= Weglot <-> Shopify locale sync (unchanged) ========= */
(function () {
  // 1) Map Weglot code -> Shopify code (edit to match Admin → Settings → Languages)
  // If your languages are 'fr' and 'nl' (generic), just map fr->fr, nl->nl.
  var SHOPIFY_CODE = {
    'en': 'en',
    'fr': 'fr-BE',   // <-- change to 'fr' OR 'fr-FR' if that's your published code
    'nl': 'nl-BE'    // <-- change to 'nl' OR 'nl-NL' if that's your published code
  };

  var URL_PREFIX = {
    'en': 'en',      // if English is root, we’ll special-case it below
    'fr': 'fr',
    'nl': 'nl'
  };

  function norm(s){ return String(s||'').trim().toLowerCase(); }

  function computeTargetPath(target){
    target = norm(target);
    var path = window.location.pathname;
    var re = /^\/(en|fr|nl)(\/|$)/i;

    if (re.test(path)) return path.replace(re, '/' + target + '$2');
    // keep EN at root:
    if (target === 'en') return path;
    return '/' + target + (path.startsWith('/') ? path : '/' + path);
  }

  async function setShopifyLocale(code, timeoutMs){
    // POST /localization and wait a moment so Shopify sets the cookie
    var controller = new AbortController();
    var timer = setTimeout(function(){ controller.abort(); }, timeoutMs || 800);

    try {
      var form = new URLSearchParams({
        utf8: '✓',
        form_type: 'localization',
        locale_code: code
      });
      await fetch('/localization', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: form.toString(),
        credentials: 'same-origin',
        signal: controller.signal
      });
    } catch(e) {
      // ignore (we still navigate)
    } finally {
      clearTimeout(timer);
    }
  }

  async function goTo(targetWeglotCode){
    var wg = norm(targetWeglotCode);
    var shopCode = SHOPIFY_CODE[wg] || wg; // fallback

    // 1) Compute next path by subfolder 'fr'/'nl' (EN at root)
    var nextPath = computeTargetPath(wg);
    var needNav  = (location.pathname !== nextPath);

    // 2) Set Shopify locale and wait a tick so Liquid sees it
    await setShopifyLocale(shopCode, 800);

    // 3) Navigate if path must change
    if (needNav) {
      var url = nextPath + location.search + location.hash;
      location.assign(url);
    } else {
      // No nav (same path) -> hard reload to ensure Liquid renders correct JSON
      location.reload();
    }
  }

  function getShopifyLocale(){
    return norm((window.Shopify && Shopify.locale) || document.documentElement.getAttribute('lang') || '');
  }

  // Wire Weglot
  function wire(){
    if (!(window.Weglot && Weglot.on)) return false;

    Weglot.on('languageChanged', function(newLang){
      goTo(newLang);
    });

    // Keep Weglot’s UI in sync with Shopify on load
    Weglot.on('switchersReady', function(){
      try {
        var wgCur = (Weglot.getCurrentLang && Weglot.getCurrentLang()) || null;
        var htmlLang = document.documentElement.getAttribute('lang') || '';
        // Don’t trust html[lang] here — just let our on-load sync below handle it.
        // Optional: if you want the switcher to reflect the URL locale immediately:
        var pref = (location.pathname.match(/^\/(fr|nl)(\/|$)/i) || [,'en'])[1].toLowerCase();
        if (wgCur && pref && wgCur !== pref && Weglot.switchTo) Weglot.switchTo(pref);
      } catch(_){}
    });

    return true;
  }
  if (!wire()) document.addEventListener('DOMContentLoaded', wire);

  // B) On-load force sync
  (function syncOnLoad(){
    var m = location.pathname.match(/^\/(fr|nl)(\/|$)/i);
    var urlCode = m ? m[1].toLowerCase() : 'en';
    var wantShopCode = SHOPIFY_CODE[urlCode] || urlCode;
    var curShopCode  = getShopifyLocale();

    // Avoid loops
    if (sessionStorage.getItem('locale-sync-done') === '1') return;

    if (norm(curShopCode) !== norm(wantShopCode)) {
      sessionStorage.setItem('locale-sync-done', '1');
      setShopifyLocale(wantShopCode, 800).then(function(){
        // Reload so Liquid picks up the correct request.locale
        location.reload();
      });
    }
  })();

  // C) <html lang="..."> should be set via theme.liquid:
  // <html lang="{{ request.locale.iso_code }}">
})();
